export default {
  path: '/apply',
  title: ' 新闻宣传申请',
  icon: 'folder',
  hideSub: false,
  children: (pre => [
    {
      title: '活动采写',
      icon: 'cubes',
      path: '/interview',
      children: [
        {
          title: '提交申请',
          icon: 'pencil',
          path: `/interview/apply`
        },
        {
          title: '申请审批',
          icon: 'list',
          path: `/interview/review`
        },
        {
          title: '任务认领',
          icon: 'cubes',
          path: `/interview/task`
        },
        {
          title: '日程安排',
          icon: 'calendar',
          path: `/interview/calendar`
        }
      ]
    },
    {
      title: '延时发布',
      icon: 'calendar',
      path: '/news-delay',
      children: [
        {
          title: '新申请',
          icon: 'edit',
          path: `${pre}news-delay/update`
        },
        {
          title: '申请列表',
          icon: 'list',
          path: `${pre}news-delay/list`
        },
        {
          title: '申请审批',
          icon: 'list',
          path: `${pre}news-delay/review`
        }
      ]
    },
    {
      title: '删改内容',
      icon: 'paper-plane',
      path: '/news-update',
      children: [
        {
          title: '新申请',
          icon: 'edit',
          path: `${pre}news-update/update`
        },
        {
          title: '申请列表',
          icon: 'list',
          path: `${pre}news-update/list`
        },
        {
          title: '申请审批',
          icon: 'list',
          path: `${pre}news-update/review`
        }
      ]
    },
    {
      title: '条幅海报大屏',
      icon: 'building',
      path: '/poster-banner',
      children: [
        {
          title: '新申请',
          icon: 'edit',
          path: `${pre}poster-banner/update`
        },
        {
          title: '申请列表',
          icon: 'list',
          path: `${pre}poster-banner/list`
        },
        {
          title: '申请审批',
          icon: 'list',
          path: `${pre}poster-banner/review`
        }
      ]
    },
    // {
    //   title: '提交申请',
    //   icon: 'pencil',
    //   path: `/interview/apply`
    // },
    // {
    //   title: '申请审批',
    //   icon: 'list',
    //   path: `/interview/review`
    // },
    // {
    //   title: '任务认领',
    //   icon: 'cubes',
    //   path: `/interview/task`
    // },
    // {
    //   title: '日程安排',
    //   icon: 'calendar',
    //   path: `/interview/calendar`
    // }
  ])('/apply/')
}
